import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { Company } from './Company';
import { DrmSettings } from './DrmSettings';
import { Edition } from './Edition';
import { Item } from './Item';

export interface Book extends Item {
  isActive?: boolean;
  deactivatedAt?: Date;

  publisherId: number;
  publisher?: Company;

  isbn?: string;
  title: string;
  description: string;

  activeEditionId?: number;
  activeEdition?: Edition;

  drmSettings?: DrmSettings;
  coverImageUrl?: string;

  authors?: string[];
  language?: string;
  numberOfPages?: number;

  editions?: Edition[];

  // only used for create to store for first edition
  key?: string;
  bookOutlineId?: number;
}

export const translateBookFromTransport = (attributes: any): any => {
  const { description } = attributes;
  return {
    ...attributes,
    description: isBase64(description) ? base64Decode(description) : description,
  };
};

export const translateBookForTransport = (attributes: any): any => {
  const { description } = attributes;
  return {
    ...attributes,
    description: !isBase64(description) ? base64Encode(description) : description,
  };
};
